import {observer} from "mobx-react-lite";
import {Typography} from "@mui/material";
import {ChartTitle} from "../../../../entity/enums/chart-title";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import PreviewIcon from "@mui/icons-material/Preview";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import React from "react";
import {StatusWidgetProps} from "../../../../entity/props/widget/status-widget-props";

import '../../../../assets/css/widget/status-widget.css';

const StatusWidget = (props: StatusWidgetProps): JSX.Element => {

    const getWidgetClass = (): string => {
        switch (props.status) {
            case ChartTitle.OPEN_ORDERS:
                return 'status-widget open';

            case ChartTitle.PENDING_REVIEW_ORDERS:
                return 'status-widget pending-review';

            case ChartTitle.PENDING_APPROVAL_ORDERS:
                return 'status-widget pending-approve';

            case ChartTitle.ON_HOLD_ORDERS:
                return 'status-widget on-hold';

            default:
                return 'status-widget completed';

        }
    }

    const getDotClass = (): string => {
        switch (props.status) {
            case ChartTitle.OPEN_ORDERS:
                return 'status-dot open';

            case ChartTitle.PENDING_REVIEW_ORDERS:
                return 'status-dot pending-review';

            case ChartTitle.PENDING_APPROVAL_ORDERS:
                return 'status-dot pending-approve';

            case ChartTitle.ON_HOLD_ORDERS:
                return 'status-dot on-hold';

            default:
                return 'status-dot completed';

        }
    }

    const renderWidget = (): JSX.Element => {
        switch (props.status) {
            case ChartTitle.OPEN_ORDERS:
                return <>
                        <FolderCopyIcon className={'status-icon open'}/>
                        <Typography className={'status-text open'}>{props.status}</Typography>
                       </>

            case ChartTitle.PENDING_REVIEW_ORDERS:
                return <>
                        <PreviewIcon className={'status-icon pending-review'}/>
                        <Typography className={'status-text pending-review'}>{props.table ? props.status.split(' ')[1] : props.status}</Typography>
                       </>

            case ChartTitle.PENDING_APPROVAL_ORDERS:
                return <>
                        <PendingActionsIcon className={'status-icon pending-approve'}/>
                        <Typography className={'status-text pending-approve'}>{props.table ? props.status.split(' ')[1] : props.status}</Typography>
                       </>

            case ChartTitle.ON_HOLD_ORDERS:
                return <>
                        <StopCircleIcon className={'status-icon on-hold'}/>
                        <Typography className={'status-text on-hold'}>{props.status}</Typography>
                       </>

            default:
                return <>
                        <CheckCircleRoundedIcon className={'status-icon completed'}/>
                        <Typography className={'status-text completed'}>{props.status}</Typography>
                       </>
        }
    }

    return (
        <Typography className={getWidgetClass()}>
            <Typography className={getDotClass()}/>
                {
                    renderWidget()
                }
        </Typography>
    );
}

export default observer(StatusWidget);
